import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import querystring from 'query-string';
import labelRequest from '../labelRequest';

export default function getAllWishlistItems(wishlistConfigs) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, options } = wishlistConfigs;

    invariant(baseUrl, 'baseUrl is a required param of getAllWishlistItems()');
    invariant(brandId, 'brandId is a required param of getAllWishlistItems()');
    invariant(country, 'country is a required param of getAllWishlistItems()');
    invariant(uberToken, 'uberToken is a required param of getAllWishlistItems()');
    invariant(clientId, 'clientId is a required param of getAllWishlistItems()');

    const headers = { 'Content-Type': 'application/json' };

    const optionalQuery = options && Object.keys(options).length > 0 ? `?${querystring.stringify(options)}` : '';
    const fetchUrl = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/wishlist/v2/@self/item${optionalQuery}`;

    return labelRequest(
        authenticatedRequest(new Request(fetchUrl, { headers: new Headers(headers), method: 'GET' }), uberToken, clientId, clientSecret),
        'getAllWishlistItems',
    );
}
